import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';

@Injectable({ providedIn: 'root' })
export class MetadataService {
    private apiUrl = environment.apiUrl;

    private metadata = {
        developmentorders: {
            dateOnlyFields: ['startingDate', 'desiredCompletionDate'],
            timeOnlyFields: [],
        },
        measurements: {
            dateOnlyFields: ['receipt', 'issued', 'return'],
            timeOnlyFields: [],
        },
        measurementresults: {
            dateOnlyFields: ['deliveredToIa'],
            timeOnlyFields: [],
        },
    };

    getMetadataForEndpoint(endpoint: string) {
        if (endpoint.indexOf(this.apiUrl) !== -1) {
            endpoint = endpoint.substring(this.apiUrl.length);
        }
        endpoint = endpoint.split('/')[0];
        return this.metadata[endpoint];
    }
}
